import {useNavigate, useLocation, Link} from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { cciLogo } from "../../helpers/images";
import GoogleAuth from "./GoogleAuth";

const Login = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let auth = useAuth();

  let from = location.state?.from?.pathname || "/";

  const handleLogin = (credential) => {
    auth.login(credential, () => {
      navigate(from, { replace: true });
    });
  };

  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xs w-full space-y-8">
          <div>
            <Link to="/">
              <img
                className="mx-auto h-12 w-auto"
                src={cciLogo}
                alt="CCI Logo"
              />
            </Link>

            <h2 className="mt-6 text-center text-xl font-medium text-gray-900">Log into your account</h2>
          </div>

          <GoogleAuth onSuccess={handleLogin} />
        </div>
      </div>
    </>
  )
};

export default Login;
